import { render, staticRenderFns } from "./picture-in-picture.vue?vue&type=template&id=5862d48b&"
import script from "./picture-in-picture.vue?vue&type=script&lang=js&"
export * from "./picture-in-picture.vue?vue&type=script&lang=js&"
import style0 from "./picture-in-picture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports